import React from "react";
import { Button } from "antd";

type Props = {
  returnOrderId: number | null;
  canCreate: boolean;
  createUrl: string;
};

export default function CreateReturnOrderButton({ returnOrderId, canCreate, createUrl }: Props) {
  const hasReturnOrder = !!returnOrderId;
  return (
    <Button disabled={hasReturnOrder || !canCreate} onClick={() => window.open(createUrl)}>
      {hasReturnOrder ? "已建立退貨單" : "退貨"}
    </Button>
  );
}
